<app-dialog [dialogWithInput]="dialog">
    <div class="row">
        <app-form-field [size]="12" label="Texte à reformuler" [required]="true">
            <app-rich-text-editor #editor
                                  [parentFormGroup]="formGroup" parentFormControlName="text"
                                  [audioTranscriptionConfig]="audioTranscriptionConfig">
            </app-rich-text-editor>
        </app-form-field>
    </div>
    <app-button dialog-actions [disabled]="!formGroup.valid" fill="solid" size="small"
                iconName="sparkles" label="Corriger"
                (clickEvent)="spellCheck()" [loading]="loading"></app-button>
</app-dialog>